import { ShieldCheck, Lock, FileCheck2, Coins, HeartHandshake } from "lucide-react";

const GUARANTEES = [
  {
    icon: ShieldCheck,
    title: "Copertura assicurativa totale",
    desc: "Ogni trasloco è coperto da assicurazione completa contro ogni imprevisto durante il ritiro, il trasporto e la consegna.",
  },
  {
    icon: Lock,
    title: "Imballaggio certificato",
    desc: "Materiali professionali e tecniche dedicate per cristalleria, opere d'arte, elettronica e arredi di pregio.",
  },
  {
    icon: FileCheck2,
    title: "Contratto chiaro, zero sorprese",
    desc: "Preventivo scritto, dettagliato e onesto. Nessun costo nascosto, mai. Quello che firmi è quello che paghi.",
  },
  {
    icon: Coins,
    title: "Risarcimento garantito",
    desc: "Nell'improbabile caso di danno, gestiamo tutto noi. Risposta entro 48 ore. Risarcimento veloce e trasparente.",
  },
  {
    icon: HeartHandshake,
    title: "Squadre selezionate",
    desc: "Operatori formati, identificabili e con anni di esperienza. Entrano in casa vostra come professionisti, escono come persone di fiducia.",
  },
];

export default function Insurance() {
  return (
    <section
      id="sicurezza"
      data-testid="insurance-section"
      className="relative py-24 lg:py-32 bg-brand-ink text-white overflow-hidden"
    >
      <div className="absolute inset-0 opacity-[0.06] grain pointer-events-none" />
      <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-brand-primary/30 blur-[140px] hidden md:block" />
      <div className="absolute -bottom-40 -left-40 w-[500px] h-[500px] rounded-full bg-brand-secondary/20 blur-[140px] hidden md:block" />

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-32">
            <div className="reveal">
              <div className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase font-bold text-brand-muted">
                <span className="w-8 h-px bg-brand-muted" />
                La promessa
              </div>
              <h2 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-[64px] leading-[0.95] tracking-tight text-white mt-5 text-balance">
                Protetti.<br />
                <span className="text-brand-muted">Al 100%.</span><br />
                <span className="text-white/90">Sempre.</span>
              </h2>
              <p className="text-lg text-white/80 mt-6 leading-relaxed max-w-md">
                Quando ci affidate i vostri ricordi, non state comprando un servizio: state acquistando <strong className="text-white">tranquillità totale</strong>.
                È così che ci siamo guadagnati la fiducia di migliaia di famiglie siciliane.
              </p>

              {/* Shield visual */}
              <div className="mt-10 inline-flex items-center gap-5">
                <div className="shield-shine relative w-24 h-24 rounded-2xl bg-gradient-to-br from-brand-primary to-brand-secondary flex items-center justify-center border border-white/10">
                  <ShieldCheck className="w-12 h-12 text-white relative z-10" />
                </div>
                <div>
                  <div className="font-display font-extrabold text-4xl text-white leading-none">100%</div>
                  <div className="text-sm uppercase tracking-[0.2em] text-brand-muted mt-2">Coperti & garantiti</div>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 space-y-4">
            {GUARANTEES.map(({ icon: Icon, title, desc }, i) => (
              <div
                key={title}
                data-testid={`guarantee-${i}`}
                className={`reveal reveal-delay-${(i % 4) + 1} group bg-white/[0.04] border border-white/10 hover:border-white/30 hover:bg-white/[0.07] rounded-2xl p-7 transition-all duration-500`}
              >
                <div className="flex items-start gap-5">
                  <div className="w-12 h-12 rounded-xl bg-white/10 border border-white/10 flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform">
                    <Icon className="w-6 h-6 text-brand-muted" />
                  </div>
                  <div>
                    <h3 className="font-display font-bold text-xl lg:text-2xl text-white tracking-tight">
                      {title}
                    </h3>
                    <p className="text-white/70 mt-2 leading-relaxed">{desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
